import { cn } from "@/lib/utils";

export function ApplyStepper({ step }: { step: 1 | 2 | 3 }) {
  return (
    <div className="flex items-center gap-3">
      {[1, 2, 3].map((n) => (
        <div key={n} className="flex items-center gap-3">
          <span
            className={cn(
              "h-2.5 w-2.5 rounded-full transition-colors",
              n <= step ? "bg-bronze-600" : "bg-bronze-600/20",
            )}
          />
          {n < 3 && (
            <span
              className={cn(
                "h-px w-8",
                n < step ? "bg-bronze-600" : "bg-bronze-600/20",
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
}